(function () {
  var LOG = "[ProductPoints]";
  var CACHE_KEY = "summit_smile_earn_rate";
  var CACHE_MAX_AGE = 30 * 60 * 1000; // 30 minutes

  function isPurchaseRule(rule) {
    var name = (rule?.name || rule?.title || rule?.actionText || "").toLowerCase();
    return name.includes("order") || name.includes("purchase") || name.includes("buy") || name.includes("spend");
  }

  function extractRate(rule) {
    var rv = rule?.rewardValue ?? rule?.reward_value ?? null;
    if (rv?.type === "variable") {
      var v = rv.variable;
      if (v) {
        return {
          pointsPer: v.value ?? v.points ?? v.pointsPerUnit ?? 1,
          perDollar: v.perAmount ?? v.per_amount ?? 1,
        };
      }
    }
    return null;
  }

  function getCachedRate() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var cached = JSON.parse(raw);
      if (Date.now() - cached.at > CACHE_MAX_AGE) return null;
      return cached.rate;
    } catch (_e) { return null; }
  }

  function setCachedRate(rate) {
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ rate: rate, at: Date.now() })); } catch (_e) { /* ignore */ }
  }

  async function fetchEarnRate() {
    var cached = getCachedRate();
    if (cached) return cached;

    var bridge = window.SummitSmileBridge;
    if (!bridge?.initSmilePublic) return null;

    try {
      var Smile = await bridge.initSmilePublic();
      if (!Smile || !Smile.earningRules?.get) return null;

      var rules = await Smile.earningRules.get();
      if (!rules?.length) return null;

      var purchaseRule = null;
      for (var i = 0; i < rules.length; i++) {
        if (isPurchaseRule(rules[i])) { purchaseRule = rules[i]; break; }
      }
      if (!purchaseRule) return null;

      var rate = extractRate(purchaseRule);
      if (rate) setCachedRate(rate);
      return rate;
    } catch (e) {
      console.warn(LOG + " failed to fetch earn rate", e);
      return null;
    }
  }

  function calcPoints(priceCents, rate) {
    if (!rate || !priceCents) return 0;
    var dollars = priceCents / 100;
    return Math.floor((dollars / rate.perDollar) * rate.pointsPer);
  }

  function renderBadge(container, points) {
    if (!container || points <= 0) return;
    container.textContent = "Earn " + points.toLocaleString() + " points with this purchase";
    container.hidden = false;
  }

  function getProductPrice() {
    // Read from Shopify product JSON on the page
    var meta = document.querySelector('[data-product-json], [data-product-id]');
    if (meta) {
      try {
        var json = JSON.parse(meta.textContent);
        if (json?.selected_or_first_available_variant?.price) return json.selected_or_first_available_variant.price;
        if (json?.price) return json.price;
      } catch (_e) { /* fallback below */ }
    }

    // Fallback: read from Shopify's global product object
    if (window.ShopifyAnalytics?.meta?.product?.variants?.length) {
      var v = window.ShopifyAnalytics.meta.product.variants[0];
      if (v.price) return v.price;
    }

    return null;
  }

  async function init() {
    var badge = document.getElementById("smile-product-earn-points");
    if (!badge) return;

    var rate = await fetchEarnRate();
    if (!rate) return;

    // Initial render
    var priceCents = getProductPrice();
    if (priceCents) renderBadge(badge, calcPoints(priceCents, rate));

    // Update on variant change
    document.addEventListener("variant:changed", function (e) {
      var newPrice = e?.detail?.variant?.price ?? e?.detail?.price ?? null;
      if (newPrice) renderBadge(badge, calcPoints(newPrice, rate));
    });

    // Also listen to Shopify's native variant change
    document.addEventListener("change", function (e) {
      if (!e.target.closest("[data-variant-id], .product-form__input")) return;
      // Small delay for Shopify to update the price
      setTimeout(function () {
        var p = getProductPrice();
        if (p) renderBadge(badge, calcPoints(p, rate));
      }, 150);
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
